<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row">
      <div class="col-6">
        <h1>Combos</h1>
      </div>
      <div class="col-6 text-end">
        <button class="btn btn-primary mt-3" @click="abrir(null)">Adicionar Combo</button>
      </div>
    </div>
    <hr/>

    <app-table v-if="!loading" :empty="lista.length === 0" empty-message="Nenhum combo cadastrado."
    :colunas="[{ label: 'Nome' }, { label: 'Itens' }, { label: 'Preço', align: 'right' }, { label: 'Ativo' }, { label: '' }]">
      <app-trow
        v-for="combo in lista" :key="combo.id"
        :data="[
          {value: combo.name},
          {value: resumoItens(combo)},
          {value: combo.price, type: 'currency', align: 'right'},
          {value: combo.active, type: 'boolean'}
        ]"
      >
      <template #actions>
        <button class="btn btn-sm btn-primary me-2" @click="abrir(combo)">
          <i class="bi bi-pencil me-2"></i>Editar
        </button>
        <button v-show="isAdmin" @click="excluir(combo)" class="btn btn-sm btn-danger">
          <i class="bi bi-trash me-2"></i>Excluir
        </button>
      </template>
      </app-trow>
    </app-table>

    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Modal de cadastro/edição -->
    <div class="modal fade" id="modal_combo" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-lg">
        <form class="modal-content" @submit.prevent="salvar">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? 'Editar combo' : 'Novo combo' }}</h5>
            <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-8">
                <label class="form-label" for="txtNome">Nome</label>
                <input v-model="form.name" required maxlength="255" class="form-control" id="txtNome" placeholder="Ex.: Combo Festa Completa">
              </div>
              <div class="col-md-4">
                <label class="form-label" for="txtPreco">Preço do combo</label>
                <input v-model.number="form.price" required type="number" step="0.01" min="0" class="form-control" id="txtPreco">
              </div>
              <div class="col-12">
                <label class="form-label" for="txtDesc">Descrição</label>
                <textarea v-model="form.description" maxlength="2000" rows="2" class="form-control" id="txtDesc"></textarea>
              </div>
              <div class="col-12">
                <div class="form-check form-switch">
                  <input v-model="form.active" class="form-check-input" type="checkbox" role="switch" id="chkAtivo">
                  <label class="form-check-label" for="chkAtivo">Ativo (aparece na vitrine)</label>
                </div>
              </div>
            </div>

            <h6 class="mt-4">Itens do combo</h6>
            <div v-for="(linha, i) in form.items" :key="i" class="row g-2 align-items-center mb-2">
              <div class="col-7">
                <select v-model="linha.id_item" required class="form-select form-select-sm" aria-label="Item">
                  <option :value="null" disabled>Selecione o item</option>
                  <option v-for="item in itensDisponiveis" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <div class="col-3">
                <div class="input-group input-group-sm">
                  <input v-model.number="linha.quantity" required type="number" min="1" class="form-control" aria-label="Quantidade">
                  <span class="input-group-text">un</span>
                </div>
              </div>
              <div class="col-2 text-end">
                <button type="button" class="btn btn-sm btn-outline-danger" @click="form.items.splice(i, 1)" :disabled="form.items.length === 1" aria-label="Remover item">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
            <button type="button" class="btn btn-sm btn-outline-primary" @click="form.items.push({ id_item: null, quantity: 1 })">
              <i class="bi bi-plus me-1"></i>Adicionar item
            </button>

            <p class="small text-muted mt-3 mb-0">
              Valor dos itens avulsos (preço por evento): <strong>{{ money(valorAvulso) }}</strong>
              <span v-if="form.price && valorAvulso > form.price"> — economia de {{ money(valorAvulso - form.price) }} para o cliente.</span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" @click="closeModal" class="btn btn-secondary">Cancelar</button>
            <button type="submit" :disabled="saving" class="btn btn-primary">
              <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive, computed } from 'vue';
import { Modal } from "bootstrap";
import { combos } from '@/models/combos';
import { itens } from '@/models/itens';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "ComboView",
  components: {
    PainelLayout,
    Breadcrumb,
    AppTable, AppTrow
  },
  setup() {

    const toastStore = useToastStore();
    const model = combos();
    const modelItens = itens();
    const { isAdmin, isUser, isOpeto } = usePermissions();

    const lista = ref([]);
    const itensDisponiveis = ref([]);
    const loading = ref(false);
    const saving = ref(false);
    let modal = null;

    const formVazio = () => ({ id: null, name: '', description: '', price: null, active: true, items: [{ id_item: null, quantity: 1 }] });
    const form = reactive(formVazio());

    const valorAvulso = computed(() => form.items.reduce((soma, linha) => {
      const item = itensDisponiveis.value.find(i => i.id === linha.id_item);
      return soma + (item ? Number(item.unit_price) * (linha.quantity || 0) : 0);
    }, 0));

    async function list() {
      loading.value = true;
      try {
        lista.value = await model.list();
      } catch (error) {
        toastStore.error('Erro ao carregar combos: ' + parseError(error));
      }
      loading.value = false;
    }

    function abrir(combo) {
      Object.assign(form, formVazio());
      if (combo) {
        Object.assign(form, {
          id: combo.id,
          name: combo.name,
          description: combo.description ?? '',
          price: Number(combo.price),
          active: !!combo.active,
          items: combo.items.map(ci => ({ id_item: ci.id_item, quantity: ci.quantity })),
        });
      }
      modal = new Modal(document.getElementById('modal_combo'));
      modal.show();
    }

    function closeModal() {
      if (modal) modal.hide();
    }

    async function salvar() {
      const ids = form.items.map(l => l.id_item);
      if (new Set(ids).size !== ids.length) {
        toastStore.warning('O mesmo item aparece mais de uma vez; ajuste a quantidade em uma linha só.');
        return;
      }
      saving.value = true;
      try {
        if (form.id) await model.update({ ...form });
        else await model.store({ ...form });
        toastStore.success('Combo salvo.');
        closeModal();
        list();
      } catch (error) {
        toastStore.error('Erro ao salvar combo: ' + parseError(error));
      }
      saving.value = false;
    }

    async function excluir(combo) {
      if (!confirm(`Excluir o combo "${combo.name}"?`)) return;
      try {
        await model.delet(combo.id);
        toastStore.success('Combo excluído.');
        list();
      } catch (error) {
        toastStore.error('Erro ao excluir combo: ' + parseError(error));
      }
    }

    function resumoItens(combo) {
      return combo.items.map(ci => `${ci.quantity}x ${ci.item?.name ?? '?'}`).join(', ');
    }

    function money(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    onMounted(async () => {
      list();
      try {
        itensDisponiveis.value = await modelItens.list();
      } catch (error) {
        toastStore.error('Erro ao carregar itens: ' + parseError(error));
      }
    });

    return {
      lista, itensDisponiveis, loading, saving, form, valorAvulso,
      abrir, closeModal, salvar, excluir, resumoItens, money,
      isAdmin, isUser, isOpeto
    }
  }
}
</script>
